<template>
  <div :key="index" class="personal-fence-edit">
    <div class="name">
      <span class="title">{{$t('supervise.fenceName')}}:</span>
      <a-input style="width: 270px" v-model="fenceName"></a-input>
    </div>
    <div class="mode">
      <span class="title">{{$t('supervise.forbidType')}}:</span>
      <a-radio-group :defaultValue="item.opt || 2" size="small" v-model="opt">
        <a-radio :value="1">{{$t('global.forbidIn')}}</a-radio>
        <a-radio :value="2">{{$t('global.forbidOut')}}</a-radio>
      </a-radio-group>
    </div>
    <div class="time">
      <span class="title">{{$t('supervise.timeOption')}}:</span>
      <a-time-picker
        style="width: 130px"
        :defaultValue="defaultstartTime"
        @change="startChange"
        format="HH:mm"
        :placeholder="$t('supervise.selecteTimeTip')"
      />
      <span style="width: 10px">~</span>
      <a-time-picker
        style="width: 130px"
        :defaultValue="defaultendTime"
        @change="endChange"
        format="HH:mm"
        :placeholder="$t('supervise.selecteTimeTip')"
      />
    </div>
    <PersonalFenceMap :opt="opt" v-model="mapData" fenceStatu="edit" />
    <a-button class="btn" type="primary" :disabled="disabled" @click="commitEditFence(item.id)">{{$t('supervise.commitEdit')}}</a-button>
    <a-button class="btn" @click="qiutEdit(index)">{{$t('global.cancel')}}</a-button>
  </div>
</template>
<script>
import PersonalFenceMap from '@components/common/PersonalFenceMap'
import moment from 'moment'
export default {
  components: {
    PersonalFenceMap
  },
  props: {
    item: {
      required: true,
      type: Object
    },
    index: {
      required: true
    }
  },
  data () {
    return {
      fenceName: '',
      opt: '',
      defaultstartTime: '',
      defaultendTime: '',
      startTime: '',
      endTime: '',
      mapData: ''
    }
  },
  computed: {
    disabled () {
      return false
    }
  },
  methods: {
    qiutEdit (index) {
      this.$emit('quitEdit', index)
    },
    // validateParams (newFenceData) {
    //   if (newFenceData) {
    //     Object.keys(newFenceData).map((key) => {
    //       if (typeof newFenceData.key === 'object') {
    //         this.validateParams(newFenceData.key)
    //       } else {
    //         if (newFenceData.key !== this.item.key) {
    //           return true
    //         }
    //       }
    //     })
    //   }
    // },
    commitEditFence (id) {
      console.log(this.defaultendTime)
      // if (!this.startTime) {
      //   this.startTime = moment(this.defaultstartTime).unix()
      // }
      // if (!this.endTime) {
      //   this.endTime = moment(this.defaultendTime).unix()
      // }
      // 需要考虑当数据未改变的情况
      let fenceData = Object.assign({}, this.item, {
        applyAll: true,
        name: this.fenceName,
        type: this.mapData.type,
        id,
        coordType: 'BD09',
        opt: this.opt,
        parameter: this.mapData.parameter,
        // acl: (this.startTime && this.endTime) ? [`${this.startTime}~${this.endTime}~1`] : []
        acl: [`${this.startTime || moment(this.defaultstartTime).unix()}~${this.endTime || moment(this.defaultendTime).unix()}~1`]
      })
      // debugger
      this.$emit('commitEdit', fenceData)
    },
    startChange (time) {
      // console.log(moment(time).unix())
      // this.startTime = moment(time).valueOf()
      this.startTime = moment(time).unix()
    },
    endChange (time) {
      // console.log(moment(time).unix())
      // this.endTime = moment(time).valueOf()
      this.endTime = moment(time).unix()
    },
    initPage () {
      this.fenceName = this.item.name
      this.opt = this.item.opt
      this.mapData = {
        type: this.item.type,
        parameter: this.item.parameter
      }
      if (this.item.acl && this.item.acl.length > 0) {
        let [start, end, lev] = this.item.acl[0].split('~')
        // console.log(start, end)
        if (start && end) {
          this.defaultstartTime = moment(parseInt(start) * 1000).isValid() ? moment(parseInt(start) * 1000) : moment().startOf('day')
          // console.log(moment(parseInt(end) * 1000).isValid())
          this.defaultendTime = moment(parseInt(end) * 1000).isValid() ? moment(parseInt(end) * 1000) : moment().endOf('day')
        } 
      } else {
        this.defaultstartTime = moment().startOf('day')
        this.defaultendTime = moment().endOf('day')
      }
    }
  },
  mounted () {
    // console.log(this.item)
  },
  created () {
    // console.log(this.item)
    this.initPage()
  }
}
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.personal-fence-edit {
  div {
    margin: 5px 0;
    .title {
      margin-right: 10px;
      margin-left: 5px; 
      // color: #999;
      color: @heading-color;
    }
  }
  .btn {
    box-sizing: border-box;
    width: 20%;
    // margin-right: 15px;
  }
}
</style>

